import { render, staticRenderFns } from "./add_language_modal.vue?vue&type=template&id=b013db8e&scoped=true"
import script from "./add_language_modal.vue?vue&type=script&lang=js"
export * from "./add_language_modal.vue?vue&type=script&lang=js"
import style0 from "./add_language_modal.vue?vue&type=style&index=0&id=b013db8e&prod&scoped=true&lang=css"
import style1 from "./add_language_modal.vue?vue&type=style&index=1&id=b013db8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b013db8e",
  null
  
)

export default component.exports